// extracted by mini-css-extract-plugin
export default {"supplierLink":"SupplierLink_supplierLink__35XtF","supplierLinkIcon":"SupplierLink_supplierLinkIcon__6NyMG"};